import React from 'react'
import { PageNotFoundDiv } from './style'
import {Link} from 'react-router-dom'

function PageNotFound() {
    return (
        <PageNotFoundDiv>
            <h3>
                This page is not found
            </h3>

            <Link to='/'>
                <h5>
                     Home        
                </h5>
            </Link>
            
        </PageNotFoundDiv>
    )
}

export default PageNotFound
